// @flow

import { RECEIVED_MENUS } from './constants';
import type { Actions } from './actions';
import type { Menus } from './types';

const initialState: Menus = {
  footer_bottom_menu: {
    ID: 0,
    name: '',
    slug: '',
    description: '',
    count: 0,
    items: [],
  },
  footer_menu: {
    ID: 0,
    name: '',
    slug: '',
    description: '',
    count: 0,
    items: [],
  },
  header_menu: {
    ID: 0,
    name: '',
    slug: '',
    description: '',
    count: 0,
    items: [],
  },
};

export type State = typeof initialState;

export default (state: State = initialState, action: Actions): State => {
  switch (action.type) {
    case RECEIVED_MENUS:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
};
